(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const searchWrappers = document.querySelectorAll('.search-wrapper:not(.search-wrapper--mobile-always)');

    searchWrappers.forEach((wrapper) => {
      const searchToggle = wrapper.querySelector('.search-toggle');
      const searchAction = wrapper.querySelector('.search-action');
      const searchClose = wrapper.querySelector('.search-close');
      const searchInput = wrapper.querySelector('input[type="search"], input[name="q"]');

      if (searchToggle && searchAction) {
        searchToggle.addEventListener('click', function () {
          searchAction.classList.add('is-open');
          if (searchInput) {
            searchInput.focus();
          }
        });
      }

      if (searchClose && searchAction) {
        searchClose.addEventListener('click', function () {
          searchAction.classList.remove('is-open');
          if (searchInput) {
            searchInput.value = '';
          }
        });
      }

      // Close search when clicking outside
      document.addEventListener('click', function (event) {
        if (searchAction && searchAction.classList.contains('is-open')) {
          if (!wrapper.contains(event.target)) {
            searchAction.classList.remove('is-open');
          }
        }
      });

      // Close search on escape key
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && searchAction && searchAction.classList.contains('is-open')) {
          searchAction.classList.remove('is-open');
          if (searchInput) {
            searchInput.value = '';
          }
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
